import React, { useEffect } from "react";
import { MsalProvider, MsalAuthenticationTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { InteractionType, EventType, EventMessage } from "@azure/msal-browser";
import authProvider, { authRequest } from "./authProvider";
import { useDispatch, useSelector } from "react-redux";
import { AAD_ACCOUNT_ADDED, AAD_LOGIN_SUCCESS, AAD_REDIRECT_END } from "./redux/actions";
import { userSelector } from "../common/redux/selectors";

export const Component: React.FC<{}> = function({ children }) {
  const dispatch = useDispatch();
  const user = useSelector(userSelector);

  useEffect(() => {
    const callbackId = authProvider.addEventCallback((msg: EventMessage) => {
      console.log("An auth event is being processed:")
      console.log(msg);
      switch (msg.eventType) {
        case EventType.LOGIN_SUCCESS:
          dispatch({ type: AAD_LOGIN_SUCCESS, payload: msg.payload });
          break;
        case EventType.ACCOUNT_ADDED:
          dispatch({ type: AAD_ACCOUNT_ADDED, payload: msg.payload });
          break;
        case EventType.HANDLE_REDIRECT_END:
          if (!user || !user.token)
            dispatch({ type: AAD_REDIRECT_END });
          break;
        default:
          break;
      }
    });

    return () => {
      if (!!callbackId)
        authProvider.removeEventCallback(callbackId);
    }
  });

  return (
    <MsalProvider instance={authProvider} >
      <MsalAuthenticationTemplate
        interactionType={InteractionType.Redirect}
        authenticationRequest={authRequest}
      >
        {children}
      </MsalAuthenticationTemplate>
      <UnauthenticatedTemplate>
        You are not authorised to access this application
      </UnauthenticatedTemplate>
    </MsalProvider>
  );
}